import {call, put, takeEvery, select} from 'redux-saga/effects';
import service from '../../services/ocularis/ocularisService';
import {errorBookmarkForPane, fetchBookmarkForPane} from "../bookmarks/actions";


function* startBookmark(action) {
    const {pane, width, height, camId, streamId, timeBounds, url} = action;
    const { token } = yield select(state => state.API);

    const requestId = service.generateId();

    try {
        yield call(() => service.initBookmark({ pane, token, width, height, url, streamId }));
        yield put(fetchBookmarkForPane(pane));

    } catch (e) {
        service.cancelRequest(requestId);
        yield put(errorBookmarkForPane(pane))
    }
}

export default function* () {
    yield takeEvery('startBookmarkPane', startBookmark)
}